import { COLORS } from '@btime/constants'
import { capitalizeIfLower, formatDate } from '@btime/helpers'
import { compose, path, prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { SmallText, Title } from '../../../components/presentation/Text'
import { useIsBulkExecution, useServiceOrder } from './_load/ServiceOrderLoader'
import { useSessionPermission } from '@btime/react-session'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const BulkModalHeader = () => {
  const serviceOrder = useServiceOrder()
  const checklistName = path(['checklist', 'name'], serviceOrder)

  return (
    <>
      <Grid justify="flex-start" gutter={0.3}>
        <Col flex={1}>
          <SmallText size="xsmall" bold color={COLORS.dark3}>
            {serviceOrder.bulk.count} atividades selecionadas
          </SmallText>
          <Title size="h4" noMargin>
            Execução em massa {checklistName ? `— ${checklistName}` : ''}
          </Title>
          <SmallText color={COLORS.dark3}>
            As respostas preenchidas aqui serão aplicadas a todas as atividades selecionadas.
          </SmallText>
        </Col>
        <Col flex={1}></Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

const ModalHeader = () => {
  const { t } = useTranslation('serviceOrders')
  const serviceOrder = useServiceOrder()
  const isBulk = useIsBulkExecution()
  const canViewServiceOrderInternalId = useSessionPermission('canViewServiceOrderInternalId')

  if (isBulk) return <BulkModalHeader />

  const title = serviceOrder?.name || compose(capitalizeIfLower, path(['checklist', 'name']))(serviceOrder)
  const createdAt = compose(formatDate('DD/MM/YYYY HH:mm'), prop('insertedAt'))(serviceOrder)

  return (
    <>
      <Grid justify="flex-start" gutter={0.3}>
        <Col flex={1}>
          {canViewServiceOrderInternalId && (
            <SmallText size="xxsmall" color={COLORS.dark3}>{`#${serviceOrder.id}`}</SmallText>
          )}
          <SmallText size="xsmall" bold color={COLORS.dark3}>
            {serviceOrder.yearlyId}
          </SmallText>
          <Title size="h4" noMargin>
            {t('execution.title', { title })}
          </Title>
          <SmallText color={COLORS.dark3}>
            {t('fields.createdAt')} {createdAt}
          </SmallText>
        </Col>
        <Col flex={1}></Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
